var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none']},[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
      label:(_vm.label + " (" + _vm.displayValue + ")"),
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id
    },false)):_vm._e(),_c('div',{staticClass:"form-slider__container"},[_c('VueSlider',_vm._b({attrs:{"value":_vm.mergedValue,"disabled":_vm.disabled},on:{"change":_vm.update}},'VueSlider',_vm.settings,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }